module.exports = __webpack_public_path__ + "img/icon-skip-end-inactive.7c4bca8e.svg";